import { AxDropdown } from "@axess/limestone";
import tippy, { Instance, Props } from 'tippy.js';
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxCounter } from "../../Limestone/AxCounter/AxCounter";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { QuantitySelection } from "./QuickSelection/QuantitySelection";

@ModuleName("TV4LandingQuickSelection")
export class LandingQuickSelection implements AxInit {
    init: initData;
    mobileInterface: LandingQuickSelectionMobilePortlet;
    quantitySelectionInterface: QuantitySelection;

    currentGroupId: number = -1;
    private currentSelectionPosition: SearchStates = SearchStates.Category;

    public counter: QuickSelectionQuantityCounter[] = [];

    catDropdown: AxDropdown = new AxDropdown();
    prodDropdown: AxDropdown = new AxDropdown();
    dateDropdown: AxDropdown = new AxDropdown();
    quantityDropdown: AxDropdown = new AxDropdown();
    currentSearchDate: moment.Moment;

    public datePicker: AxDatePicker;

    public initComplete = false;

    constructor(private _i18nHelper = new I18nHelper(),
        private _AxLimestone = new AxLimeStone()) { }

    AxInit(init: initData): void {
        this.init = init;

        this.mobileInterface = new LandingQuickSelectionMobilePortlet();
        this.mobileInterface.init(this, init, this._i18nHelper);

        this.quantitySelectionInterface = new QuantitySelection();
        this.quantitySelectionInterface.init(this);

        $('[data-tv4-quickselection="submit"]').on('click', (e) => {
            let mode = $(e.delegateTarget).attr('data-target') as "desktop" | "mobile";
            this.addToCart(mode);
        });

        this.initDropdowns();
        this.initComplete = true;
    }

    initDropdowns() {
        const closeOnWindowScroll = (dropdown) => ($parent) => $(window).on('scroll', () => dropdown.close($parent));
        const dropdownOptions = (dropdown) => ({ searchBar: true, onOpen: closeOnWindowScroll(dropdown) });
        this.catDropdown.init(`[data-tv4-quickselection--dropdown="cat"]`, dropdownOptions(this.catDropdown));
        this.prodDropdown.init(`[data-tv4-quickselection--dropdown="prod"]`, dropdownOptions(this.prodDropdown));
        this.dateDropdown.init(`[data-tv4-quickselection--dropdown="date"]`, dropdownOptions(this.dateDropdown));
        this.quantityDropdown.init(`[data-tv4-quickselection--dropdown="quantity"]`, dropdownOptions(this.quantityDropdown));
        
        let defaultProd = Object.prototype.hasOwnProperty.call(this.prodDropdown, 'val') && this.prodDropdown.val();

        let tippyDefaultOptions = {
            placement: 'bottom',
            trigger: 'mouseenter click',
            interactive: false,
            offset: [0, 16],
            role: 'info',
            theme: 'dark',
            onShow(tooltipInstance) {
                if (!$(tooltipInstance.reference).parent().is('[disabled]')) {
                    return false;
                }
            }
        };

        //@ts-ignore
        tippy('[data-tv4-quickselection--dropdown="prod"] .ax-dropdown__trigger', {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.SelectCategoryFirst)
        });
        //@ts-ignore
        tippy('[data-tv4-quickselection--dropdown="date"] .ax-dropdown__trigger', {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.SelectTicketFirst)
        });
        //@ts-ignore
        tippy('[data-tv4-quickselection--dropdown="quantity"] .ax-dropdown__trigger', {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.SelectDateFirst)
        });

        this.catDropdown.getSelectObserver().subscribe((x: string) => {
            const groupId = parseInt(x);

            this.prodDropdown.resetSelection();

            this.currentGroupId = groupId;
            this.setTicketOptions(groupId);
        });

        if (defaultProd) {
            const $popper = this.getPopper(this.prodDropdown);
            const $target = $popper.find(`.ax-dropdown__item[data-groupid=${this.currentGroupId}][data-value=${defaultProd}]`);
            this.prodDropdown.select($target);
        }

        this.prodDropdown.getSelectObserver().subscribe((x: string) => {
            this.initDatePicker();

            if (this.datePicker && this.init.setDefaultDate) {
                if (this.init?.closedDays || this.init?.closedDays?.length === 0) {
                    this.datePicker.setDate(moment());
                }
                else {
                    let day = moment().format("YYYY-MM-DD");
                    while (this.init?.closedDays?.some(x => x === day)) {
                        day = moment().add(1, 'days').format("YYYY-MM-DD");
                    }
                    
                    this.datePicker.setDate(moment(day, "YYYY-MM-DD"));
                }
            }
        });

        $('.clickable-card[data-url]').on('click', (e: JQuery.ClickEvent) => {
            if ($(e.target).closest('a, button').length > 0) return;
            const url = $(e.currentTarget).data('url');
            if (url) {
                window.location.href = url;
            }
        });
    }

    toggleSelection() {
        $('[data-tv4-quickselection--overlay="category"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Category);
        $('[data-tv4-quickselection--overlay="product"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Product);
        $('[data-tv4-quickselection--overlay="date"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Date);
        $('[data-tv4-quickselection--overlay="quantity"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Quantity);

        $('.prod_selection__prod-close--cancel')
            .toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Category);
        $('.prod_selection__prod-close--back')
            .toggleClass('d-none', this.currentSelectionPosition === SearchStates.Category);
    }

    initDatePicker() {
        const $popperDatePopper = this.getPopper(this.dateDropdown);
        const $popperProdPopper = this.getPopper(this.prodDropdown);
        const $selectedOption = $($popperProdPopper.find('.ax-dropdown__item.selected'));

        if ($selectedOption.length === 0) return;

        const preDateAble = $selectedOption.attr('data-predateable') === 'true';
        $('[data-tv4-quickselection--dropdown="date"]').toggleClass('d-none', !preDateAble);

        this.dateDropdown.resetSelection();
        this.prodDropdown.getElements().attr('disabled', null);
        this.dateDropdown.getElements().attr('disabled', null);
        this.quantityDropdown.getElements().attr('disabled', '');

        if (!preDateAble) {
            this.quantitySelectionInterface.getQuantitySelection(moment());
        }

        const $datePicker = $popperDatePopper.find('[data-tv4-quickselection--dropdown="picker"]');
        $datePicker.html('');

        const startDate = moment($selectedOption.attr('data-start'), 'YYYY-MM-DD');
        const blockedDates = this.init?.closedDays?.map(x => moment(x, "YYYY-MM-DD"));

        this.datePicker = new AxDatePicker();        

        this.datePicker.Init({
            StartOfWeek: this.init.startOfWeek,
            Lang: this.init.lang,
            StartDate: startDate,
            DayRange: 0,
            Target: $datePicker[0],
            Mode: Mode.Inline,
            EndDate: null,
            monthsShown: 1,
            BlockedDates: blockedDates,
        });

        this.datePicker.ActivationSubject.subscribe((x: Cell) => {
            this.setDate(x);
        });

        this.mobileInterface.initDatePicker(startDate, blockedDates);
    }

    setTicketOptions(groupId: number) {
        if (isNaN(groupId)) return;
        this.counter = [];
        const $popper = this.getPopper(this.prodDropdown);
        const $overlay = $('[data-tv4-quickselection--overlay="product"]');

        $popper.find('.ax-dropdown__item').removeClass('d-none')
        $popper.find('.ax-dropdown__item').not(`[data-groupid=${groupId}]`).addClass('d-none');

        $overlay.find('button[data-groupid]').removeClass('d-none')
        $overlay.find('button[data-groupid]').not(`[data-groupid=${groupId}]`).addClass('d-none');

        this.prodDropdown.resetSelection();
        this.dateDropdown.resetSelection();
        this.prodDropdown.getElements().attr('disabled', null);
        this.dateDropdown.getElements().attr('disabled', '');
        this.quantityDropdown.getElements().attr('disabled', '');

        $('[data-tv4-quickselection--dropdown="quantity-single"]').html('');
        $(`[data-tv4-quickselection--dropdown="quantity"]`).removeClass('d-none');
        this.quantitySelectionInterface.renderQuantityLines(0, 0);
    }

    setDate(cell: Cell) {
        if (cell != null) {
            this.dateDropdown.setValue(cell.Date.format(this.init.datePattern));
            this.dateDropdown.close();
            this.currentSearchDate = cell.Date;

            this.quantitySelectionInterface.getQuantitySelection(cell.Date);
        }
    }

    getPopper(dropdown: AxDropdown): JQuery<HTMLElement> {
        //@ts-ignore
        const instance = dropdown.getElements()[0]?._tippy as Instance<Props>;
        let $popper = $(instance?.popper);

        return $popper;
    }

    addToCart(mode: "desktop" | "mobile") {
        const tripleArr = (this.prodDropdown.getValue() as string).split('-');

        const $popperProdPopper = this.getPopper(this.prodDropdown);
        const $selectedOption = $($popperProdPopper?.find('.ax-dropdown__item.selected'));
        const requestURL = $selectedOption?.attr('data-add');
        let request;

        if (requestURL?.toLowerCase().includes('/package/')) {
            request = {
                projNr: tripleArr[0],
                packTariffSheetNo: tripleArr[1],
                packageNr: tripleArr[2],
                date: (this.currentSearchDate ?? moment()).format('YYYY-MM-DD'),
                packagePositions: []
            }
        } else {
            request = {
                projNr: tripleArr[0],
                poolNr: tripleArr[1],
                ticketTypeId: tripleArr[2],
                date: (this.currentSearchDate ?? moment()).format('YYYY-MM-DD'),
                personTypes: []
            }
        }

        for (let c of this.counter.filter(x => x.mode === mode)) {
            if (c.counter.GetValue() < 1) continue;

            const subTypeIdentifier = $(c.counter.getElement()).attr('data-subtypeidentifier');
            let toAdd;

            if (requestURL.toLowerCase().includes('/package/')) {
                toAdd = {
                    packPos: subTypeIdentifier,
                    quantity: c.counter.GetValue(),
                    linkedArticles: []
                }
            } else {
                toAdd = {
                    personTypeId: subTypeIdentifier,
                    quantity: c.counter.GetValue(),
                    linkedArticles: []
                }
            }

            let $parent;

            if (mode === "desktop") {
                $parent = $(this.quantitySelectionInterface.quantitySelectionTippy.popper);
            } else {
                $parent = $('[data-tv4-quickselection--overlay="quantity"]');
            }

            let count = 0;
            for (let article of $parent.find(`[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier="${subTypeIdentifier}"],[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier--copy="${subTypeIdentifier}"]`).not('.d-none')) {
                for (const checkbox of $(article).find('[data-tv4-quickselection-article]')) {
                    let $checkbox = $(checkbox);
                    const articleNr = $checkbox.attr('data-tv4-quickselection-article');
                    const checked = $checkbox.prop('checked');

                    toAdd.linkedArticles.push({
                        articleNr: articleNr,
                        checked: checked,
                        index: count
                    });
                }
                count++;
            }

            request.personTypes?.push(toAdd);
            request.packagePositions?.push(toAdd);
        }

        if ((request.personTypes?.length ?? 0) === 0 && (request.packagePositions?.length ?? 0) === 0) return;

        this._AxLimestone.LockButton($('[data-tv4-quickselection="submit"]')[0]);
        AxessViewer.loadPartialView(requestURL, request, (result) => {
            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: result,
                continueShoppingPath: '/Tickets',
                btn: '.tv4_prod-selection__addToCart-submit',
                ResetQuantity: false,
                queryAddition: '?ref=pi'
            });
            this._AxLimestone.UnlockButton($('[data-tv4-quickselection="submit"]')[0]);
        }, {
            silent: true,
            skipShoppingCartReload: false,
            addCulturInfo: false
        });
    }
}


class LandingQuickSelectionMobilePortlet {
    private currentSelectionPosition: SearchStates = SearchStates.Category;
    private mainModule: LandingQuickSelection;
    private initData: initData;

    public datePickerMobile: AxDatePicker;
    private _i18nHelper: I18nHelper;

    init(rentalMainModule: LandingQuickSelection, init: initData, i18nHelper: I18nHelper) {
        this.initData = init;
        this.mainModule = rentalMainModule;
        this._i18nHelper = i18nHelper;
        this.initEvents();
    }

    initDefaultValues() {
        const defaultCat = this.mainModule.catDropdown.val();
        const defaultProd = this.mainModule.prodDropdown.getSelected();
        const defaultDate = this.mainModule.datePicker?.ActivationSubject?.value;

        this.currentSelectionPosition = SearchStates.Category;

        if (defaultCat != null)
            this.currentSelectionPosition = SearchStates.Product;

        if (defaultProd.length !== 0)
            this.currentSelectionPosition = SearchStates.Date;

        if (defaultCat != null && defaultProd.length !== 0 && defaultDate != null) {
            this.datePickerMobile.setDate(defaultDate.Date);
            return;
        }

        this.toggleSelection();
        this.printSummary();
    }

    initEvents() {
        $('[data-tv4-quickselection="toggle"]').on('click', () => {
            this.initDefaultValues();
            $('[data-tv4-quickselection="overlay"]').toggleClass('active');
        });

        $('[data-tv4-quickselection="close"]').on('click', () => {
            this.currentSelectionPosition = SearchStates.Category;
            this.resetSelections();
            this.toggleSelection();

            $('[data-tv4-quickselection="overlay"]').toggleClass('active');
        });

        $('[data-tv4-quickselection--overlay="category"] button').on('click', (e) => {
            const value = $(e.delegateTarget).attr('data-value');
            this.selectCategory(value);
        });

        $('[data-tv4-quickselection--overlay="product"] button').on('click', (e) => {
            const link = $(e.delegateTarget).attr('data-link');
            this.selectProduct(link);
        });

        $('[data-tv4-quickselection="back"]').on('click', () => this.goBackOrClose());
    }

    initDatePicker(startDate: moment.Moment, blockedDates: moment.Moment[]) {
        $('[data-tv4-quickselection--overlay="date-picker"]').html('');
        $('[data-tv4-quickselection--overlay="date-legend"]').html('');
        this.datePickerMobile = new AxDatePicker();
        this.datePickerMobile.Init({
            StartOfWeek: this.initData.startOfWeek,
            Lang: this.initData.lang,
            StartDate: startDate,
            DayRange: 0,
            Target: $('[data-tv4-quickselection--overlay="date-picker"]')[0],
            Mode: Mode.Endless,
            LegendTarget: '[data-tv4-quickselection--overlay="date-legend"]',
            monthsShown: 2,
            scrollTargetQuerySelector: '[data-tv4-quickselection--overlay="date"]',
            BlockedDates: blockedDates,
        });

        this.datePickerMobile.ActivationSubject.subscribe((x: Cell) => {
            if (x != null) {
                this.mainModule.datePicker.setDate(x.Date);
                this.currentSelectionPosition = SearchStates.Quantity;
                this.toggleSelection();
            }
        });
    }

    goBackOrClose() {
        const originalPosition = this.currentSelectionPosition;
        this.currentSelectionPosition--;

        if (originalPosition == SearchStates.Quantity && this.datePickerMobile.ActivationSubject.value == null) {
            this.currentSelectionPosition--;
        }

        if (originalPosition !== SearchStates.Category) {
            switch (this.currentSelectionPosition) {
                case SearchStates.Date:
                    this.resetCounters();
                    this.mainModule.datePicker.resetDateSelection();
                    this.mainModule.dateDropdown.resetSelection();
                    this.datePickerMobile.resetDateSelection();
                    break;
                case SearchStates.Product:
                    this.resetCounters();
                    this.mainModule.prodDropdown.resetSelection();
                    break;
                case SearchStates.Category:
                    this.mainModule.catDropdown.resetSelection();
                    break;

            }
        } else {
            $('[data-tv4-quickselection="overlay"]').toggleClass('active');
            this.resetSelections();
        }
        this.toggleSelection();
    }

    resetCounters() {
        const counters = this.mainModule.counter;
        for (let c of counters) {
            c.counter.resetValue();
        }
    }

    resetSelections() {
        this.mainModule.dateDropdown.resetSelection();
        this.mainModule.catDropdown.resetSelection();
        this.mainModule.prodDropdown.resetSelection();
        this.mainModule.quantityDropdown.resetSelection();

        this.datePickerMobile?.resetDateSelection();
        this.mainModule.datePicker?.resetDateSelection();

        this.resetCounters();
    }

    getTotalQuantity(mode: "desktop" | "mobile") {
        const counters = this.mainModule.counter.filter(x => x.mode === mode);

        let totalQuantity = 0;
        for (let c of counters) {
            totalQuantity += c.counter.GetValue();
        }

        return totalQuantity;
    }

    renderSubmitButtonText() {
        const $mobileSubmit = $('[data-tv4-quickselection="footer"] [data-tv4-quickselection="submit"] span');
        const totalQuantity = this.getTotalQuantity("mobile");

        $('[data-tv4-quickselection="continue"]').toggleClass('d-none', totalQuantity === 0);
        $mobileSubmit.html(this._i18nHelper.GetTranslation(Translations.TicketsX, totalQuantity));
        this.printSummary();
    }

    printSummary() {
        const $currentCategory = this.mainModule.catDropdown.getSelected();
        const $currentProduct = this.mainModule.prodDropdown.getSelected();

        if (this.currentSelectionPosition !== SearchStates.Quantity) {
            $('[data-tv4-quickselection="continue"]').addClass('d-none');
        }

        if ($currentCategory.length == 0 || this.currentSelectionPosition === SearchStates.Category) {
            $('[data-tv4-quickselection="summary"]').html(``);
            $('[data-tv4-quickselection="footer"]').addClass('d-none');
            return;
        }

        $('[data-tv4-quickselection="footer"]').removeClass('d-none');

        const wrapper = document.createElement('div');
        wrapper.classList.add('d-flex', 'ax-my-1-n', 'ax-gap-1', 'flex-wrap');


        const totalQuantity = this.getTotalQuantity("mobile");

        if (totalQuantity > 0 && this.currentSelectionPosition === SearchStates.Quantity) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex');

            const iconWrapper = document.createElement('div');
            const iconElem = document.createElement('i');
            iconElem.classList.add('las', 'la-user', 'ax-mr-1');
            iconWrapper.appendChild(iconElem);
            innerWrapper.appendChild(iconWrapper);

            const textWrapper = document.createElement('div');
            const locationElem = this._i18nHelper.GetTranslation(Translations.TicketsX, totalQuantity);
            textWrapper.innerHTML = locationElem;
            innerWrapper.appendChild(textWrapper);
            wrapper.appendChild(innerWrapper);
        }

        if ($currentProduct.length > 0) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex');

            const iconWrapper = document.createElement('div');
            const iconElem = document.createElement('i');
            iconElem.classList.add('las', 'la-ticket-alt', 'ax-mr-1');
            iconWrapper.appendChild(iconElem);
            innerWrapper.appendChild(iconWrapper);

            const textWrapper = document.createElement('div');
            const locationElem = $currentProduct.html();
            textWrapper.innerHTML = locationElem;
            innerWrapper.appendChild(textWrapper);
            wrapper.appendChild(innerWrapper);
        }

        if (this.datePickerMobile?.ActivationSubject?.value != null) {
            const innerWrapper = document.createElement('div');
            innerWrapper.classList.add('d-flex');

            const iconWrapper = document.createElement('div');
            const iconElem = document.createElement('i');
            iconElem.classList.add('las', 'la-calendar', 'ax-mr-1');
            iconWrapper.appendChild(iconElem);
            innerWrapper.appendChild(iconWrapper);

            const textWrapper = document.createElement('div');
            const currentCell: Cell = this.datePickerMobile.ActivationSubject.value;
            textWrapper.innerHTML = currentCell.Date.format('ll');
            innerWrapper.appendChild(textWrapper);
            wrapper.appendChild(innerWrapper);
        }

        const innerWrapper = document.createElement('div');
        innerWrapper.classList.add('d-flex');

        const iconWrapper = document.createElement('div');
        const iconElem = document.createElement('i');
        iconElem.classList.add('las', 'la-list-alt', 'ax-mr-1');
        iconWrapper.appendChild(iconElem);
        innerWrapper.appendChild(iconWrapper);

        const textWrapper = document.createElement('div');
        const locationElem = $currentCategory.html();
        textWrapper.innerHTML = locationElem;
        innerWrapper.appendChild(textWrapper);
        wrapper.appendChild(innerWrapper);

        $('[data-tv4-quickselection="summary"]').html(wrapper);
    }

    selectProduct(link: string) {        
        const elem = this.mainModule.getPopper(this.mainModule.prodDropdown).find(`[data-link="${link}"]`);
        this.mainModule.prodDropdown.select(elem);

        const $selectedOption = this.mainModule.prodDropdown.getSelected();
        const preDateAble = $selectedOption.attr('data-predateable') === 'true';

        this.currentSelectionPosition = preDateAble ? SearchStates.Date : SearchStates.Quantity;
        this.mainModule.initDatePicker();
        this.toggleSelection();
    }

    selectCategory(value: string) {
        this.mainModule.catDropdown.setValue(value);

        this.currentSelectionPosition = SearchStates.Product;
        this.mainModule.setTicketOptions(parseInt(value));
        this.toggleSelection();
    }

    toggleSelection() {
        $('[data-tv4-quickselection="overlay"] .prod_selection__scrollable')[0].scrollTo(0, 0);
        $('[data-tv4-quickselection--overlay="category"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Category);
        $('[data-tv4-quickselection--overlay="product"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Product);
        $('[data-tv4-quickselection--overlay="date"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Date);
        $('[data-tv4-quickselection--overlay="quantity"]').toggleClass('d-none', this.currentSelectionPosition !== SearchStates.Quantity);

        $('.prod_selection__prod-close--back')
            .toggleClass('d-none', this.currentSelectionPosition === SearchStates.Category);
        this.printSummary();
    }

    isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
    }
}

enum SearchStates {
    Category = 1,
    Product = 2,
    Date = 3,
    Quantity = 4,
}

interface initData {
    startOfWeek: number;
    datePattern: string;
    lang: string;
    setDefaultDate: boolean;
    closedDays: string[];
}
export class QuickSelectionQuantityCounter {
    counter: AxCounter;
    mode: "desktop" | "mobile";
}

